import { render, staticRenderFns } from "./ContactsGroupsView.vue?vue&type=template&id=a62c624e&"
import script from "./ContactsGroupsView.vue?vue&type=script&lang=js&"
export * from "./ContactsGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports